"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Portal = void 0;
var react_1 = require("react");
var react_dom_1 = require("react-dom");
var utilities_1 = require("../../utilities");
var Portal = function (_a) {
    var _b;
    var children = _a.children, _c = _a.conditional, conditional = _c === void 0 ? true : _c, target = _a.target;
    var defaultPortalContext = react_1.useContext(utilities_1.DefaultPortalContext);
    // Check for docuemnt for server-side rendered apps
    if (typeof document !== 'undefined') {
        // End early if portal isn't needed
        if (!conditional)
            return children;
        var node = (_b = target !== null && target !== void 0 ? target : defaultPortalContext) !== null && _b !== void 0 ? _b : document.body;
        return react_dom_1.createPortal(children, node);
    }
    return null;
};
exports.Portal = Portal;
//# sourceMappingURL=Portal.js.map